import {join} from '@esgi/ui-kit/utils';
import {ForwardedRef, forwardRef, useCallback, useState} from 'react';
import {
	TableHeaderColumn,
	TableHeaderColumnProps,
} from './table-header-column';
import SortIcon from '../../../icons/sort-icon';
import styles from './styles.module.less';

export enum SortDirection {
	Asc = 'asc',
	Desc = 'desc',
}

export type TableHeaderColumnSoratbleOwnProps = {
	isActive: boolean;
	onClick: (sortDirection: SortDirection) => void;
	disableSorting?: boolean;
};

type TableHeaderColumnSoratbleProps = Omit<TableHeaderColumnProps, 'onClick'> &
	TableHeaderColumnSoratbleOwnProps;

export const TableHeaderColumnSortable = forwardRef(
	(
		{
			onClick,
			children,
			isActive,
			disableSorting,
			...tableHeaderColumnProps
		}: TableHeaderColumnSoratbleProps,
		ref: ForwardedRef<HTMLDivElement>
	) => {
		const [sortDirection, setSortDirection] = useState(SortDirection.Asc);

		const onTableColumnClick = useCallback(() => {
			if (disableSorting) {
				return;
			}

			const newSortDirection =
				sortDirection === SortDirection.Asc
					? SortDirection.Desc
					: SortDirection.Asc;

			setSortDirection(newSortDirection);
			onClick(newSortDirection);
		}, [onClick, sortDirection, disableSorting]);

		return (
			<TableHeaderColumn
				{...tableHeaderColumnProps}
				ref={ref}
				className={join(!disableSorting && styles.cursorPointer, tableHeaderColumnProps.className)}
				onClick={onTableColumnClick}
			>
				{children}
				{!disableSorting && (
					<div>
						<SortIcon
							className={styles.icon}
							direction={isActive ? sortDirection : undefined}
						/>
					</div>
				)}
			</TableHeaderColumn>
		);
	}
);
